import {
  Checkbox,
  FormControlLabel,
  Grid,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from "@material-ui/core"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { getDefaultTab } from "./ActivityMethods"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuitemsul: {
      width: "100%",
    },
    marginTop10: { marginTop: "10px" },
  })
)

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      ul: {
        paddingTop: 0,
      },
    },
  },
}

export default function ActivityTab({ value, activitySpecId, onChange, onIsHiddenChange, ...props }) {
  const classes = useStyles()
  const { t } = useTranslation()
  const [category, setCategory] = useState(value?.category ?? null)
  const [customize, setCustomize] = useState(false)
  const [defaultTab, setDefaultTab] = useState(null)
  const [isHidden, setIsHidden] = useState(!!value?.spec ? value.spec?.includes("hidden") : false)
  const tabs = {
    assess: "Assess",
    learn: "Learn",
    manage: "Manage",
    prevent: "Portal",
  }

  useEffect(() => {
    if ((category || []).length === 1 && category[0] === defaultTab) setCustomize(false)
    else setCustomize(true)
    onChange(category)
  }, [category])

  useEffect(() => {
    onIsHiddenChange(isHidden)
  }, [isHidden])

  useEffect(() => {
    if (category === null) {
      setDefault()
    }
  }, [])

  useEffect(() => {
    if (!customize && category === null) {
      setDefault()
    }
  }, [customize])

  const setDefault = async () => {
    let defaultTab = await getDefaultTab(activitySpecId)
    if (!!defaultTab) {
      setCategory([defaultTab])
      setDefaultTab(defaultTab)
    }
  }

  return (
    <Grid item lg={12} md={9} xs={12}>
      <Grid container spacing={2}>
        <Grid item lg={6} sm={6} xs={12}>
          <FormControlLabel
            className={classes.marginTop10}
            control={
              <Checkbox
                checked={customize}
                onChange={() => {
                  setCustomize(!customize)
                }}
                name="customize"
                color="primary"
              />
            }
            label={`${t("Customize which Tab this Activity appears in")}`}
          />
          {!!onIsHiddenChange && (
            <FormControlLabel //FIXME: This is a button to toggle 'hidden' surveys (for follow-ups)
              className={classes.marginTop10}
              control={
                <Checkbox
                  checked={!isHidden}
                  onChange={() => setIsHidden(!isHidden)}
                  name="customize"
                  color="primary"
                />
              }
              label={`${t("Visible to participant")}`}
            />
          )}
        </Grid>
        <Grid item lg={6} sm={6} xs={12}>
          <Select
            labelId="demo-multiple-name-label"
            id="demo-multiple-name"
            multiple
            disabled={!customize}
            value={category || []}
            onChange={(event) => {
              setCategory(typeof event.target.value === "string" ? event.target.value.split(",") : event.target.value)
            }}
            input={<OutlinedInput />}
            MenuProps={MenuProps}
            className={classes.menuitemsul}
            renderValue={(selected) => (category || []).map((c) => t(tabs[c])).join(", ")}
          >
            {Object.keys(tabs).map((key) => (
              <MenuItem key={key} value={key}>
                <Checkbox checked={(category || []).indexOf(key) > -1} />
                <ListItemText primary={t(tabs[key])} />
              </MenuItem>
            ))}
          </Select>
          {(category || []).length === 0 && (
            <Typography variant="caption">
              {`${t("This Activity will only appear in the Feed tab if a schedule is configured.")}`}
            </Typography>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}
